import { Equipment } from './../index';

export class MinesiteEquipment {
    public BatchFinished = false;
    public Reload = true;
    public Progress = '';
    public IsLoading: boolean;
    public MinesiteId: number;
    public Equipment: Equipment[] = [];
}
